module.exports = __webpack_public_path__ + "static/media/addToHomeScreen.2cfa30e9.jpg";